import { ImageData } from './image-data.model';

export class ImageDataCollection {
    variants: ImageData[];

    constructor(variants: ImageData[]) {
        this.variants = variants;
    }
}
